module.exports = __webpack_public_path__ + "static/apple-icon-114x114-6f6a7ff8129d03dfaf1d9d7fbf77f202.png";